import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Hooks, Context } from '@grandvisionhq/carts-v2';
import { getDisplayName } from '@grandvisionhq/utils';

function withCart(settings) {
    return ({ readOnly =false , showQuoteLink =false  } = {})=>(PageComponent)=>{
            const displayName = getDisplayName(PageComponent);
            const WithCart = (pageProps)=>{
                const productLinkFormatter = Hooks.useGetProductLinkFormatter();
                const { cartHash , cartId  } = pageProps;
                return /*#__PURE__*/ React.createElement(Context.CartSettingsProvider, {
                    settings: swcHelpers.objectSpread({}, settings, {
                        productLinkFormatter,
                        readOnly,
                        showQuoteLink
                    }, cartHash ? {
                        cartHash
                    } : undefined, cartId ? {
                        cartId
                    } : undefined)
                }, /*#__PURE__*/ React.createElement(Context.CartProvider, null, ({ cart , refetch  })=>/*#__PURE__*/ React.createElement(PageComponent, swcHelpers.extends({}, pageProps, {
                        cart: cart,
                        refetchCart: refetch
                    }))
                ));
            };
            WithCart.getInitialProps = function() {
                var _ref = swcHelpers.asyncToGenerator(function*(ctx) {
                    const { cartId , cartHash  } = ctx.query || {};
                    if (typeof PageComponent.getInitialProps === 'function') {
                        const pageProps = yield PageComponent.getInitialProps(ctx);
                        return swcHelpers.objectSpread({}, pageProps, {
                            cartId,
                            cartHash
                        });
                    }
                    return {
                        cartId,
                        cartHash
                    };
                });
                return function(ctx) {
                    return _ref.apply(this, arguments);
                };
            }();
            WithCart.displayName = `WithCart(${displayName})`;
            return WithCart;
        }
    ;
}

export { withCart };
//# sourceMappingURL=with-cart.js.map
